/* @flow */
import { ActivityAgeConfirmation } from 'payments/constants/CopyConstants';
import BoxBody from 'components/BoxBody.jsx';
import BirthdateSelector from 'chat/components/BirthdateSelector.jsx';
import Container from 'components/Container.jsx';
import cx from 'classnames';
import Dialog from 'components/Dialog.jsx';
import DialogButton from 'components/DialogButton.jsx';
import React, { Component, PropTypes } from 'react';
import TabPanel from 'components/TabPanel.jsx';
import Tabs from 'components/Tabs.jsx';
import TitleHeader from 'components/TitleHeader.jsx';

import './styles/ActivityAgeConfirmationModal.scss';

class ActivityAgeConfirmationModal extends Component {
  static propTypes = {
    onAgeConfirmed: PropTypes.func.isRequired,
  }

  state = {
    birthdate: null,
    isChild: true,
  };

  handleClick = () => {
    const { isChild, birthdate } = this.state;
    this.props.onRequestHide();
    this.props.onAgeConfirmed(isChild, birthdate);
  }

  renderStudentAgeConfirmation() {
    return (
      <div className="ActivityAgeConfirmationModal-birthdate">
        <BirthdateSelector onChange={birthdate => this.setState({ birthdate })} />
      </div>
    );
  }

  render() {
    const { className } = this.props;
    return (
      <Dialog
        eventScreenName="ActivityAgeConfirmationModal"
        className={cx('ActivityAgeConfirmationModal', className)}>
        <BoxBody>
          <Container size="medium">
            <TitleHeader
              image={require('assets/images/payments/activity-coppa-modal.svg')}
              title={ActivityAgeConfirmation.title}
              subtext={ActivityAgeConfirmation.subtext}
            />
            <Tabs
              type="button"
              buttonSize="small">
              <TabPanel
                title={<span>I am a student</span>}
                onClick={() => this.setState({ isChild: true })}>
                {this.renderStudentAgeConfirmation()}
              </TabPanel>
              <TabPanel
                title={<span>I am a parent</span>}
                onClick={() => this.setState({ isChild: false })}
              />
            </Tabs>
            <DialogButton
              disabled={this.state.isChild && !this.state.birthdate}
              onClick={this.handleClick}>
              Done
            </DialogButton>
          </Container>
        </BoxBody>
      </Dialog>
    );
  }
}

export default ActivityAgeConfirmationModal;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityAgeConfirmationModal.jsx